/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Cons_3Inputs */

const en_pc_rv_cons_3 = /** @type {(inputs: Pc_Rv_Cons_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No generative fill and no Photoshop plug-ins`)
};

const zh_pc_rv_cons_3 = /** @type {(inputs: Pc_Rv_Cons_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有生成式填充，也不支持 Photoshop 插件`)
};

/**
* | output |
* | --- |
* | "No generative fill and no Photoshop plug-ins" |
*
* @param {Pc_Rv_Cons_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_cons_3 = /** @type {((inputs?: Pc_Rv_Cons_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Cons_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_cons_3(inputs)
	return zh_pc_rv_cons_3(inputs)
});
export { pc_rv_cons_3 as "pc.rv.cons.3" }